var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugcareLogoIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_16431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3807 30.1699L3.17907 16.9249C-0.246973 13.0737 0.0857843 7.16319 3.92438 3.7259C7.76467 0.288612 13.6541 0.622462 17.0819 4.47366L19.9052 7.30627V7.30627C20.9573 8.36478 21.0065 10.0584 20.0176 11.1762L19.7306 11.5005C18.471 12.9242 16.2708 12.9881 14.9308 11.6399L12.1556 8.8478",
    stroke: "#FF611D",
    strokeWidth: 1.70367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0947 4.47674C24.5836 1.56067 29.7668 1.56918 33.254 4.69477C37.0925 8.13205 37.427 14.0426 33.9993 17.8937L19.582 32.3583",
    stroke: "#FF611D",
    strokeWidth: 1.70367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43359 21.7961L13.683 16.8555",
    stroke: "#FF611D",
    strokeWidth: 1.70367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6459 18.9001L29.0898 15.8335",
    stroke: "#FF611D",
    strokeWidth: 1.70367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87109 11.7446L20.2273 23.1381",
    stroke: "#FF611D",
    strokeWidth: 1.70367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6897 22.1938C23.967 20.2473 23.2717 17.4705 24.0973 14.807C25.351 10.763 29.6346 8.51014 33.6654 9.77496",
    stroke: "#FF611D",
    strokeWidth: 1.70367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_16431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 33,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugcareLogoIconOrange);
export default __webpack_public_path__ + "static/media/hugcare-logoIcon_orange.26ebbea535a70106d3bdab9a3391be45.svg";
export { ForwardRef as ReactComponent };